

export enum PriceFactorMode
{
    Multiply = "multiply",
    Constant = "constant"
}
